module.exports = __webpack_public_path__ + "images/bannerIT-753e2a8e0406d32b2054148ae1d6d966.jpg";